import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Typography,
    useMediaQuery,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useCloneMapitShipOrdersMutation } from 'src/_api/mapitShipApi';

function CloneOrdersDialog({ open, onClose, selectedOrdersIds, onSuccess }) {
    const { t } = useTranslation();
    const fullScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const [cloneOrders, { isLoading }] = useCloneMapitShipOrdersMutation();

    const handleConfirm = useCallback(async () => {
        try {
            await cloneOrders({ orderIds: selectedOrdersIds }).unwrap();
            onSuccess?.();
            onClose();
        } catch {
            // error handled by RTK Query
        }
    }, [cloneOrders, selectedOrdersIds, onSuccess, onClose]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>{t('Clone Orders')}</DialogTitle>
            <Divider />
            <DialogContent>
                <Typography>
                    {t('cloneOrdersConfirmMessage')}
                </Typography>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={onClose}
                    disabled={isLoading}
                    sx={{ textTransform: 'none' }}
                >
                    {t('Cancel')}
                </Button>
                <LoadingButton
                    variant="contained"
                    loading={isLoading}
                    onClick={handleConfirm}
                    sx={{ textTransform: 'none' }}
                >
                    {t('Confirm')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}

CloneOrdersDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedOrdersIds: PropTypes.array.isRequired,
    onSuccess: PropTypes.func,
};

CloneOrdersDialog.defaultProps = {
    onSuccess: null,
};

export default memo(CloneOrdersDialog);
